import { createAsyncThunk } from "@reduxjs/toolkit";

import { type AsyncThunkCreator } from "../../../index";
import { TEAM_REDUCER_NAME } from "../types";

interface Payload {
  memberId: string;
}

export interface TeamMemberProductScope {
  /** Every product of the tenant, as the picker options. */
  products: { id: string; name: string }[];
  /** Products this member may reach resources of. */
  assignedProductIds: string[];
}

export const fetchTeamMemberProductScope = createAsyncThunk<
  TeamMemberProductScope,
  Payload,
  AsyncThunkCreator<string>
>(`${TEAM_REDUCER_NAME}/fetchTeamMemberProductScope`, async ({ memberId }, { rejectWithValue, extra: { db } }) => {
  const [productsResult, assignedResult] = await Promise.all([
    db.from("product").select("id, name").order("name"),
    db.from("team_member_product").select("productId").eq("memberId", memberId),
  ]);

  const error = productsResult.error ?? assignedResult.error;

  if (error) {
    return rejectWithValue(error.message);
  }

  return {
    products: (productsResult.data ?? []).map((product) => ({ id: product.id, name: product.name })),
    assignedProductIds: (assignedResult.data ?? []).map((row) => row.productId),
  };
});
